// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  font-size: 14px!important;
  line-height: 1.42857143!important;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/editor/editor-layout.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,iDAAiD;EACjD,0CAA0C;AAC5C","sourcesContent":["body{\n  font-size: 14px!important;\n  line-height: 1.42857143!important;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
